export default __webpack_public_path__ + "static/media/IMG-20241210-WA0024.5cdf575d.jpg";